import React from "react";
import Title from "../../components/TitleComponent";
import { Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import Details from "../../components/DetailsComponent";
import ReusableImageGallery from "../../components/ReusableImageGallery";
import TwoImageComponent from "../../components/TwoImageComponent";
import OneImageComponent from "../../components/OneImageComponent";

export default function RetreatEvent() {

  const myImages1 = [
    {
      id: 1,
      thumbnail: '/images/day1.1.jpg',
      fullSize: '/images/day1.1.jpg', 
      alt: 'Workshop Iuliana Muntean - Transfer - contratransfer in relatia parinte-terapeut',
      modalSize: 'large'
    },
    {
      id: 2,
      thumbnail: '/images/day1.2.jpg',
      fullSize: '/images/day1.2.jpg',
      alt: 'Workshop Iuliana Muntean - Transfer - contratransfer in relatia parinte-terapeut',
      modalSize: 'large'
    },
    {
      id: 3,
      thumbnail: '/images/day1.3.jpg',
      fullSize: '/images/day1.3.jpg',
      alt: 'Workshop Iuliana Muntean - Transfer - contratransfer in relatia parinte-terapeut',
      modalSize: 'large'
    },
  ];

  const myImages2 = [
    {
      id: 1,
      thumbnail: '/images/2.1.1.jpg',
      fullSize: '/images/2.1.1.jpg', 
      alt: 'Workshop Doina Cinezan - Comportamente indezirabile sau dificultati senzoriale?',
      modalSize: 'large'
    },
    {
      id: 2,
      thumbnail: '/images/2.1.2.jpg',
      fullSize: '/images/2.1.2.jpg',
      alt: 'Workshop Doina Cinezan - Comportamente indezirabile sau dificultati senzoriale?',
      modalSize: 'large'
    },
    {
      id: 3,
      thumbnail: '/images/2.1.3.jpg',
      fullSize: '/images/2.1.3.jpg',
      alt: 'Workshop Doina Cinezan - Comportamente indezirabile sau dificultati senzoriale?',
      modalSize: 'small'
    },
  ];

  const myImages3 = [
    {
      id: 1,
      thumbnail: '/images/2.2.1.jpg',
      fullSize: '/images/2.2.1.jpg', 
      alt: 'Workshop Mirela Varadi - Strategii de sprijin pentru dezoltarea comunicarii la copilul cu intarziere de limbaj',
      modalSize: 'large'
    },
    {
      id: 2,
      thumbnail: '/images/2.2.2.jpg',
      fullSize: '/images/2.2.2.jpg',
      alt: 'Workshop Mirela Varadi - Strategii de sprijin pentru dezoltarea comunicarii la copilul cu intarziere de limbaj',
      modalSize: 'large'
    }
  ];

  const myImages4 = [
    {
      id: 1,
      thumbnail: '/images/2.3.1.jpg',
      fullSize: '/images/2.3.1.jpg', 
      alt: 'Workshop Alexandra Abruden si Iulia Popa - Atelier de dezvoltare persoanala Kintsugi',
      modalSize: 'medium'
    },
    {
      id: 2,
      thumbnail: '/images/2.3.2.jpg',
      fullSize: '/images/2.3.2.jpg',
      alt: 'Workshop Alexandra Abruden si Iulia Popa - Atelier de dezvoltare persoanala Kintsugi',
      modalSize: 'small'
    },
    {
      id: 3,
      thumbnail: '/images/2.3.3.jpg',
      fullSize: '/images/2.3.3.jpg',
      alt: 'Workshop Alexandra Abruden si Iulia Popa - Atelier de dezvoltare persoanala Kintsugi',
      modalSize: 'large'
    },
        {
      id: 4,
      thumbnail: '/images/2.3.4.jpg',
      fullSize: '/images/2.3.4.jpg',
      alt: 'Workshop Alexandra Abruden si Iulia Popa - Atelier de dezvoltare persoanala Kintsugi',
      modalSize: 'small'
    },
  ];

  const myImages5 = [
    {
      id: 1,
      thumbnail: '/images/3.1.jpg',
      fullSize: '/images/3.1.jpg', 
      alt: 'Workshop Elena Patrut - Workshop: Calitatea relatiei specialist-parinte in procesul de recuperare a copilului',
      modalSize: 'large'
    },
    {
      id: 2,
      thumbnail: '/images/3.2.jpg',
      fullSize: '/images/3.2.jpg',
      alt: 'Workshop Elena Patrut - Workshop: Calitatea relatiei specialist-parinte in procesul de recuperare a copilului',
      modalSize: 'large'
    },
    {
      id: 3,
      thumbnail: '/images/3.3.jpg',
      fullSize: '/images/3.3.jpg',
      alt: 'Workshop Elena Patrut - Workshop: Calitatea relatiei specialist-parinte in procesul de recuperare a copilului',
      modalSize: 'large'
    },
  ];

  return (
    <>

    <Helmet>
        <title>Retreat dedicat specialistilor in terapia de recuperare</title>
        <meta
          name="description"
          content="Evenimentul este destinat specialistilor in terapia de recuperare (psihologi, psihopedagogi, logopezi, profesori de sprijin, specialisti familiarizati cu interventia specifica in cazul unor diagnostice precum tulburarea de spectru autist, sindrom Down, intarziere in dezvoltarea cognitiva, intarziere in dezvoltarea limbajului receptiv si expresiv) si va avea loc in perioada 22-24 august, la Chalet Transylvania, Orlat - Sibiu."
        />
        <link rel="canonical" href="https://www.psinapsis.ro/events/retreatevent" />
      </Helmet>

    <Row className="p-0 m-0">
      <Col className="d-none d-xl-block"></Col>
      <Col className="whiteBg p-0 m-0 pb-5 min-xl-screen-size">

        <Title title="Construind legaturi intre nevoie si solutii in terapia de recuperare" />

        <OneImageComponent />

        <Details normalText="Iata o scurta privire asupra workshopurilor care au avut loc:" />

    {/* Workshop 1 */}
        <div> 
          <div className="subtitle">
          <h1 className="text-left mx-auto text-decoration-underline fs-6 mb-1">Ziua 1:</h1>
        </div>  
        <div className="subtitle"> 
          <h1 className="text-left mx-auto fw-bold fs-6 mt-6 mb-4">Workshop: Transfer - contratransfer in relatia parinte-terapeut</h1>
        </div>
    
          <Details normalText="Sub indrumarea psihoterapeutului Iuliana Muntean, participantii au fost ghidati intr-un proces de analiza si reflectie personala asupra dinamicii relationale, a rolurilor jucate in interactiunea dintre parinte si terapeut, si a indicatorilor transferului si contratransferului. Astfel, s-a creat un cadru potrivit pentru explorarea limitelor personale, precum si pentru identificarea de strategii de imbunatatire a interactiunii parinte-terapeut." />

          <ReusableImageGallery images={myImages1} />
        </div>
    {/* Workshop 2 */}
        <div>
      <div className="subtitle">
        <h1 className="text-left mx-auto text-decoration-underline fs-6 mb-1">Ziua 2:</h1>
      </div>  
      <div className="subtitle"> 
        <h1 className="text-left mx-auto fw-bold fs-6 mt-6 mb-4">Workshop: Comportamente indezirabile sau dificultati senzoriale?</h1>
      </div>
    
      <Details normalText="Workshopul sustinut de colega noastra Doina Cinezan a adus raspunsuri la intrebari precum 'Ce sta la baza unui comportament indezirabil?', 'Care sunt nevoile senzoriale din spatele unei manifestari comportamentale?', 'Cum putem sprijini procesul de predare – invatare, valorificand notiuni de integrare senzoriala?'" />
      <Details normalText="Meltdown vs tantrum, autostimulari vs fixatii, nivel de activitate, dificultati de modulare - hiperreactivitate și hiporeactivitate, influenta stadiului de dezvoltare a sistemelor senzoriale primare (tactil, proprioceptiv, vestibular) in dezvoltarea ulterioara a sistemelor vizual si auditiv, asupra parcursului de dezvoltare motorie, cognitiva si verbala...discutii, exemplificari si clarificari cu impact asupra imbunatatirii intelegerii copilului si ajustarea procesului terapeutic. " />

      <ReusableImageGallery images={myImages2} />
        </div>
    {/* Workshop 3 */}
        <div>
          <div className="subtitle"> 
          <h1 className="text-left mx-auto fw-bold fs-6 mt-6 mb-4">Workshop: Strategii de sprijin pentru dezoltarea comunicarii la copilul cu intarziere de limbaj</h1>
        </div>
    
        <Details normalText="Logopedul Mirela Varadi a abordat aspecte precum comunicarea functionala, metode alternative de comunicare si implementare a unui program personalizat de interventie. Exercitiile din cadrul workshop-ului au normalizat dificultatiile ce pot sa apara si au deschis noi directii de lucru in procesul de recuperare." />

        <ReusableImageGallery images={myImages3} />
        </div>
    {/* Workshop 4 */}
        <div>
          <div className="subtitle"> 
          <h1 className="text-left mx-auto fw-bold fs-6 mt-6 mb-4">Workshop: Atelier de dezvoltare persoanala Kintsugi</h1>
        </div>
    
        <Details normalText="Alexandra Abrudean si Iulia Popa au ghidat un atelier metaforic despre schimbare, rezilienta si puterea de a-ti accepta imperfectiunile. A fost o experienta de profunzime, in care fragilitatea s-a transformat in sursa de putere si reconstructie." />
        <Details normalText="Kintsugi este arta traditionala japoneza de a repara obiectele sparte sau crapate cu ajutorul lacului de aur, punand accent pe frumusetea imperfectiunilor si a procesului de vindecare. Este si o lectie de viata: ca suntem (im)perfecti, si tocmai asta ne face frumosi." />

        <ReusableImageGallery images={myImages4} />
        </div>
    {/* Workshop 5 */}
        <div> 
          <div className="subtitle">
          <h1 className="text-left mx-auto text-decoration-underline fs-6 mb-1">Ziua 3:</h1>
        </div>  
        <div className="subtitle"> 
          <h1 className="text-left mx-auto fw-bold fs-6 mt-6 mb-4">Workshop: Calitatea relatiei specialist-parinte in procesul de recuperare a copilului</h1>
        </div>
    
          <Details normalText="Psihologul Elena Patrut a incheiat evenimentul cu o sesiune dedicata calitatii relatiei dintre specialist si parinte, incurajand o reflectie asupra parcursului profesional si asupra locului in care ne aflam astazi – cu nevoile si aspiratiile care se contureaza si care dau forma modului in care construim si hranim relatia parinte–terapeut." />

          <ReusableImageGallery images={myImages5} />
        </div>

        <TwoImageComponent />

      </Col>
      <Col className="d-none d-xl-block"></Col>
    </Row>
    </>
  );
}
